import React from 'react';
import './components/Footer.css'; // You'll create this CSS file

const Footer = () => {
  return (
    <>
      <footer className="bg-dark text-light pt-5 pb-4">
        <div className="container text-md-left">
          <div className="row text-md-left">
            {/* Company Info */}
            <div className="col-md-4 col-lg-4 col-xl-4 mx-auto mt-3">
              <h5 className="text-uppercase mb-4 fw-bold text-primary">MortBuzz Solutions India Pvt. Ltd</h5>
              <p>Corporate Identity Number (CIN):<br /><strong>U65910PN2008PLC132228</strong></p>
              <p><i className="fas fa-clock me-2"></i> Office Time: 9:30 – 6:30</p>
            </div>

            {/* Contact */}
            <div className="col-md-4 col-lg-4 col-xl-4 mx-auto mt-3">
              <h5 className="text-uppercase mb-4 fw-bold text-primary">Contact Us</h5>
              <p><i className="fas fa-envelope me-2"></i> contact@mortbuzz.in</p>
              <p><i className="fas fa-envelope me-2"></i> support@mortbuzz.in</p>
              <p><i className="fas fa-phone me-2"></i> +91 20 7963 7941</p>
              <p><i className="fas fa-headset me-2"></i> Toll Free: 1800 210 4422</p>
            </div>

            {/* Visit Us */}
            <div className="col-md-4 col-lg-4 col-xl-4 mx-auto mt-3">
              <h5 className="text-uppercase mb-4 fw-bold text-primary">Visit Us</h5>
              <p>2nd Floor, Mahadik House,<br />Bhosale Nagar, Hadapsar,<br />Pune.</p>
              <p className="mt-3"><strong>Why Wait?</strong><br />Secure Our Loan Now and Turn Your Ambitions into Achievements.</p>
            </div>
          </div>

          <hr className="my-3" />

          {/* Copyright */}
          <div className="row align-items-center">
            <div className="col-md-12 text-center">
              <p className="mb-0">&copy; 2025 All Rights Reserved by <strong>MortBuzz Solutions India Pvt. Ltd.</strong></p>
            </div>
          </div>
        </div>
      </footer>

      {/* Sticky Mobile & Tablet Buttons */}
      <div className="mobile-sticky-buttons d-lg-none fixed-bottom bg-dark text-light d-flex justify-content-around p-2 shadow-lg">
        <a href="https://mortbuzz.in/apply-loan-in-mortbuzz-india-solution/" className="btn d-flex align-items-center flex-grow-1 mx-1 gradient-btn">
          <i className="fas fa-file-signature me-2"></i> Apply Now
        </a>
        <a href="https://mortbuzz.in/overview/" className="btn d-flex align-items-center flex-grow-1 mx-1 gradient-btn">
          <i className="fas fa-percentage me-2"></i> Interest Rate
        </a>
      </div>
    </>
  );
};

export default Footer;
